export default {
    set_donationLocation: (state, payload)=> {
        Object.keys(payload).forEach(key=>{
            if (typeof state.dataRequestDonationLocation[key] !=='undefined'){
                state.dataRequestDonationLocation[key] = payload[key]
            } else (
                console.log(`ERROR: properties: ${key} not found in object: 'state.dataRequestDonationLocation'`)
            )
        })
    },
    set_dataDonationLocation: (state, payload)=> {
        if(typeof payload.responseData!=='undefined') state.dataDonationLocation.responseData = payload.responseData
        if(typeof payload.profileId!=='undefined') state.dataDonationLocation.profileId = payload.profileId
    },
    set_createBookingTab: (state, payload)=> {
        if(typeof payload.responseData!=='undefined') state.dataCreateBookingTab.responseData = payload.responseData
    },
    set_dataBookingAppointment: (state, payload)=> {
        Object.keys(payload).forEach(key=>{
            if (typeof state.dataBookingAppointment[key] !=='undefined'){
                state.dataBookingAppointment[key] = payload[key]
            } else (
                console.log(`ERROR: properties: ${key} not found in object: 'state.dataBookingAppointment'`)
            )
        })
    },
    set_entryPoint: (state, payload)=> {
        state.entryPoint = payload
    },
    set_showPage: (state, payload)=>{
        if(typeof payload.triggerDonationLocation !== 'undefined') state.showPage.triggerDonationLocation = payload.triggerDonationLocation
        if(typeof payload.triggerBookingAppointment !== 'undefined') state.showPage.triggerBookingAppointment = payload.triggerBookingAppointment

    },
    set_actionVariableDonateBlood:(state, payload)=>{
        if(typeof payload.varReschedule !== 'undefined') state.actionVariableDonateBlood.varReschedule = payload.varReschedule
    },
    set_constructorState: (state) => {
        Object.keys(state).forEach(key => {
            if (key !== 'stateDefault'){
                state[key] = JSON.parse(JSON.stringify(state.stateDefault[key]));
            }
        })
    },
}